import {FC} from "react";
import "./SpinnerIcon.scss";

export const SpinnerIcon: FC = () => {
  return (
    <span
      className="coat-spinner-icon MuiCircularProgress-root MuiCircularProgress-indeterminate MuiCircularProgress-colorPrimary css-MuiCircularProgress-root"
      style={{width: "14px", height: "14px"}}
      role="progressbar">
      <svg
        className="MuiCircularProgress-svg css-MuiCircularProgress-svg"
        viewBox="22 22 44 44">
        <circle
          className="MuiCircularProgress-circle MuiCircularProgress-circleIndeterminate css-MuiCircularProgress-circle"
          cx="44"
          cy="44"
          r="19.8"
          fill="none"
          strokeWidth="4.4"
        />
      </svg>
    </span>
  );
};
